import React from 'react';

const PreRevenueSVG = () => {
  return (
    <svg width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.39944 7.98031C2.42104 7.77988 4 6.07433 4 4C4 1.92567 2.42104 0.220125 0.39944 0.0196945C0.179604 -0.00210101 0 0.179086 0 0.4V7.6C0 7.82091 0.179604 8.0021 0.39944 7.98031Z"
        fill="#219735"
      />
    </svg>
  );
};

export default PreRevenueSVG;
